// Note:  this class does not contain model classes, hence it does not follow the model class
//        naming convention.  Since it relates directly to model classes, I decided to put it
//        in this model classes directory, at least for the present.
import { FormField } from '../form-builder/form-field.model';
import { Form } from '../form-builder/form.model';
import { FormFieldAction } from './form-field-action.model';
import { FormFieldExpression } from './form-field-expression.model';
import { FormInstanceElement } from '../form-builder/form-instance-element.model'
import { FormModeEnum } from '../../enums/form-mode.enum';
import { FieldDefinition } from '../../models/form-builder/field-definition.model';
import { IFieldDefinitionLogic } from '../../interfaces/ifield-definition-logic.interface';
import { FieldDefinitionService } from '../../services/field-definition.service';

// Define an enum for instructing
// how an action needs to be applied.
export enum FormFieldActionGuidanceEnum {
    ApplyAction = 'ApplyAction',
    RemoveAction = 'RemoveAction'
};

// Define an interface for 'listening' 
// to form field expression actions.
export interface IFormFieldExpressionActionListener {
    // Tell the listener that an
    // action needs to be performed.
    expressionTriggeredAction(formField: FormField, expression: FormFieldExpression, action: FormFieldAction, actionGuidance: FormFieldActionGuidanceEnum): void;
}

export interface IFormFieldAttributeSetter {
    setsAttributeNamed(): string;
    setFormFieldAttribute(formField: FormField, attributeName: string, attributeValue: any);
}
class RequiredNotRequiredAttributeSetter implements IFormFieldAttributeSetter {
    public constructor() { }

    public setsAttributeNamed(): string {
        return 'required';
    }
    public setFormFieldAttribute(formField: FormField, attributeName: string, attributeValue: any) {
        let requiredValue: boolean = (attributeValue != null) && (attributeValue.toString() == 'true');
        formField.required = requiredValue;
    }
}

// Define a type-safe hash of form
// field expressions by field id.
class SourceFormFieldExprData {
    public formFieldExpressions: FormFieldExpression[] = [];
}
interface IFormFieldIdToFormFieldExpressions {
    //[clientId: number]: FormFieldExpression[];
    [clientId: number]: SourceFormFieldExprData;
}

export class FormFieldExpressionListener {
    // Instance data.
    private form: Form = null;
    private listener: IFormFieldExpressionActionListener = null;

    private readonly formFieldAttributeSetters: IFormFieldAttributeSetter[] = [];

    // Constructor -- when a FormFieldExpressionListener is created, it needs
    //                an instance of IFormFieldExpressionActionListener to call.
    public constructor(formParam: Form, mode: FormModeEnum, listenerParam: IFormFieldExpressionActionListener, private fieldDefinitionService: FieldDefinitionService) {
        // Save the form and the listener.
        this.form = formParam;
        this.listener = listenerParam;

        this.formFieldAttributeSetters.push(new RequiredNotRequiredAttributeSetter());
    }

    public getFormFieldAttributeSetterForAttribute(attributeName: string): IFormFieldAttributeSetter {
        let setter: IFormFieldAttributeSetter = this.formFieldAttributeSetters.find(s => s.setsAttributeNamed() == attributeName);
        return setter;
    }

    // The following method needs to be called when a form field value changes.
    public formFieldValueChanged(formField: FormField, formInstanceElement: FormInstanceElement): void {
        // Get the expressions for the changed form field.

        // Compute/recompute field conditions with each field value changes.
        this.evaluateSourceFieldExpression(formField, formInstanceElement);
    }

    // Helper methods.
    private evaluateSourceFieldExpression(formField: FormField, formInstanceElement: FormInstanceElement): void {
        // Get the expressions for the changed form field.
        let formFieldExpressions: FormFieldExpression[] = this.form.conditionalLogicRules.filter(r => r.sourceFieldName == formField.name);

        if ((formFieldExpressions != null) && (formFieldExpressions.length > 0)) {
            for (let iExpr: number = 0; iExpr < formFieldExpressions.length; iExpr++) {
                let fieldExpr: FormFieldExpression = formFieldExpressions[iExpr];

                //let bDoesTriggerExpr: boolean = fieldExpr.valueTriggersExpression(formField, formInstanceElement);
                let bDoesTriggerExpr: boolean = fieldExpr.valueTriggersExpression(formField, formInstanceElement, this.fieldDefinitionService);
                let actionOperation: FormFieldActionGuidanceEnum = (bDoesTriggerExpr ? FormFieldActionGuidanceEnum.ApplyAction : FormFieldActionGuidanceEnum.RemoveAction);

                // Perform the reverse action for each of this expression's actions.
                if (fieldExpr.actions && (fieldExpr.actions.length > 0)) {
                    for (let iAction: number = 0; iAction < fieldExpr.actions.length; iAction++) {
                        let actionToApply: FormFieldAction = fieldExpr.actions[iAction];

                        this.listener.expressionTriggeredAction(formField, fieldExpr, actionToApply, actionOperation);
                    }
                }
            } // for
        } // if
    }
}
